// frontend/src/styles/SharedStyles.js
import styled from 'styled-components';

// Button styles
export const Button = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;

  ${props => props.primary && `
    background-color: #3b82f6;
    color: white;
    &:hover {
      background-color: #2563eb;
    }
  `}

  ${props => props.danger && `
    background-color: #dc2626;
    color: white;
    &:hover {
      background-color: #b91c1c;
    }
  `}

  ${props => props.fullWidth && `
    width: 100%;
  `}
`;

// Form input styles
export const Input = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  margin: 0.5rem 0;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  }
`;

// Form label styles
export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
`;

// Container styles
export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

// Form container
export const FormContainer = styled.div`
  max-width: 28rem;
  width: 100%;
  padding: 1.5rem;
`;

// Page title
export const PageTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 1.5rem;
`;